import { usePostHog } from 'posthog-js/react'
import { useEffect } from 'react'
import { useMe } from '../me'

/**
 * Only add data here that changes together with the user
 * to avoid unexpected data leaks.
 */
export const useIdentify = () => {
  const { me } = useMe()
  const postHog = usePostHog()
  const persistedUserId = postHog.get_distinct_id()

  useEffect(() => {
    const skipIdentify = persistedUserId === me?.userTrackingId
    if (skipIdentify || !me?.userTrackingId) {
      return
    }
    postHog.identify(me?.userTrackingId)
  }, [postHog, persistedUserId, me?.userTrackingId])
}
